export default __webpack_public_path__ + "static/market-index-treemap-d1ea2cc25e5f623449b0adea676535fb.png";